import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from "./base.sevice";
import { PaginatedSearch } from "../models/PaginatedSearch";
import { PendingPaymentRequest } from "../models/PendingPaymentRequest";

@Injectable()
export class PendingPaymentRequestService extends BaseService {

    url = `${environment.apiBaseUrl}/consumers`;

    constructor(private http: HttpClient) {
        super();
    }

    get(consumerId: string, id: string) {
        return this.http.get(`${this.url}/${consumerId}/pending-payment-requests/${id}`);
    }

    lookup(consumerId: string, criteria?: PaginatedSearch) {
        const httpParams = this.toHttpParams(criteria);
        return this.http.get(`${this.url}/${consumerId}/pending-payment-requests`, { params: httpParams });
    }

    approve(consumerId: string, item: PendingPaymentRequest) {
        return this.http.post(`${this.url}/${consumerId}/pending-payment-requests`, item);
    }
}